/* ═════════════════════════════════════════════════════════════
   REMOOD — NAVIGATION (remood-nav.js)
   Mega menus (survol + clavier) · Sticky intelligent · Header
   transparent accueil · Tiroir mobile (focus trap) · Annonces
   Réinitialisable dans l'éditeur de thème (shopify:section:load).
   ═════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ───────── Header : mega menus ───────── */

  function initHeader(header) {
    if (header.dataset.navInit) return;
    header.dataset.navInit = 'true';

    var items = header.querySelectorAll('[data-mega]');
    var veil = header.querySelector('[data-mega-veil]');
    var openItem = null;
    var hoverTimer = null;

    function setVeilTop() {
      var bottom = Math.max(header.getBoundingClientRect().bottom, 0);
      header.style.setProperty('--veil-top', bottom + 'px');
    }

    function openMega(item) {
      if (openItem === item) return;
      if (openItem) closeMega(openItem, true);
      var panel = item.querySelector('[data-mega-panel]');
      var toggle = item.querySelector('[data-mega-toggle]');
      if (!panel) return;
      setVeilTop();
      panel.hidden = false;
      requestAnimationFrame(function () {
        panel.classList.add('is-open');
      });
      item.classList.add('is-open');
      header.classList.add('is-open');
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
      openItem = item;
    }

    function closeMega(item, instant) {
      var panel = item.querySelector('[data-mega-panel]');
      var toggle = item.querySelector('[data-mega-toggle]');
      if (!panel) return;
      panel.classList.remove('is-open');
      item.classList.remove('is-open');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      if (instant || reducedMotion) {
        panel.hidden = true;
      } else {
        setTimeout(function () {
          if (!item.classList.contains('is-open')) panel.hidden = true;
        }, 230);
      }
      if (openItem === item) {
        openItem = null;
        header.classList.remove('is-open');
      }
    }

    function closeAll() {
      if (openItem) closeMega(openItem);
    }

    items.forEach(function (item) {
      var toggle = item.querySelector('[data-mega-toggle]');

      /* Exposé pour l'éditeur de thème (shopify:block:select) */
      item._megaOpen = function () { openMega(item); };
      item._megaClose = function () { closeMega(item, true); };

      /* Survol avec intention (hover uniquement sur pointeurs fins) */
      item.addEventListener('mouseenter', function () {
        if (!window.matchMedia('(hover: hover)').matches) return;
        clearTimeout(hoverTimer);
        hoverTimer = setTimeout(function () { openMega(item); }, 60);
      });
      item.addEventListener('mouseleave', function () {
        clearTimeout(hoverTimer);
        hoverTimer = setTimeout(function () {
          if (openItem === item && !item.contains(document.activeElement)) closeMega(item);
        }, 140);
      });

      /* Clavier : bouton disclosure */
      if (toggle) {
        toggle.addEventListener('click', function () {
          if (openItem === item) {
            closeMega(item);
          } else {
            openMega(item);
          }
        });
      }

      /* Fermer quand le focus quitte l'élément */
      item.addEventListener('focusout', function (e) {
        if (!item.contains(e.relatedTarget)) {
          if (openItem === item) closeMega(item);
        }
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && openItem) {
        var toggle = openItem.querySelector('[data-mega-toggle]');
        closeMega(openItem);
        if (toggle) toggle.focus();
      }
    });

    document.addEventListener('click', function (e) {
      if (openItem && !header.contains(e.target)) closeAll();
    });

    /* ───────── Sticky intelligent + transparent ───────── */

    var stickyMode = header.dataset.sticky;
    var transparent = header.classList.contains('hdr--transparent');
    var lastY = window.scrollY || 0;
    var ticking = false;

    /* Le sticky est appliqué au wrapper de section (voir remood-nav.css).
       Classe posée en JS en secours de :has(), et retirée si le réglage
       repasse à "none" (le wrapper persiste entre deux rechargements de
       section dans l'éditeur de thème). */
    var wrapper = header.closest('.shopify-section');
    if (wrapper) {
      wrapper.classList.toggle('is-sticky', stickyMode === 'always' || stickyMode === 'smart');
    }

    function onScroll() {
      var y = window.scrollY || 0;

      if (transparent) {
        header.classList.toggle('is-top', y < 12);
      }

      if (stickyMode === 'smart') {
        var goingDown = y > lastY + 4;
        var goingUp = y < lastY - 4;
        if (goingDown && y > 160 && !openItem && !header.contains(document.activeElement)) {
          header.classList.add('is-hidden');
          if (wrapper) wrapper.classList.add('is-hidden');
        } else if (goingUp || y <= 160) {
          header.classList.remove('is-hidden');
          if (wrapper) wrapper.classList.remove('is-hidden');
        }
      }

      lastY = y;
      ticking = false;
    }

    if (stickyMode === 'smart' || transparent) {
      if (transparent) header.classList.toggle('is-top', (window.scrollY || 0) < 12);
      window.addEventListener('scroll', function () {
        if (!ticking) {
          ticking = true;
          requestAnimationFrame(onScroll);
        }
      }, { passive: true });
    }
  }

  /* ───────── Tiroir mobile ───────── */

  function initDrawer(scope) {
    var drawer = scope.querySelector('[data-drawer]');
    var drawerVeil = scope.querySelector('[data-drawer-veil]');
    if (!drawer || drawer.dataset.navInit) return;
    drawer.dataset.navInit = 'true';

    var lastTrigger = null;

    function focusables() {
      return drawer.querySelectorAll(
        'a[href], button:not([disabled]), summary, input, [tabindex]:not([tabindex="-1"])'
      );
    }

    function openDrawer(trigger) {
      lastTrigger = trigger || null;
      drawer.classList.add('is-open');
      if (drawerVeil) drawerVeil.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('nav-lock');
      document.querySelectorAll('[data-drawer-open]').forEach(function (btn) {
        btn.setAttribute('aria-expanded', 'true');
      });
      var first = drawer.querySelector('[data-drawer-close]');
      if (first) first.focus();
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      if (drawerVeil) drawerVeil.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('nav-lock');
      document.querySelectorAll('[data-drawer-open]').forEach(function (btn) {
        btn.setAttribute('aria-expanded', 'false');
      });
      if (lastTrigger) lastTrigger.focus();
    }

    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-drawer-open]');
      if (opener) {
        e.preventDefault();
        openDrawer(opener);
        return;
      }
      if (e.target.closest('[data-drawer-close]')) closeDrawer();
    });

    if (drawerVeil) drawerVeil.addEventListener('click', closeDrawer);

    document.addEventListener('keydown', function (e) {
      if (!drawer.classList.contains('is-open')) return;

      if (e.key === 'Escape') {
        closeDrawer();
        return;
      }

      /* Focus trap */
      if (e.key === 'Tab') {
        var els = focusables();
        if (!els.length) return;
        var first = els[0];
        var last = els[els.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    });

    /* Navigation vers un lien : fermer le tiroir */
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('a[href]')) closeDrawer();
    });

    /* La recherche depuis le tiroir : fermer le tiroir, l'overlay prend le relais */
    drawer.querySelectorAll('.search-toggle').forEach(function (btn) {
      btn.addEventListener('click', function () {
        drawer.classList.remove('is-open');
        if (drawerVeil) drawerVeil.classList.remove('is-open');
        drawer.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('nav-lock');
      });
    });
  }

  /* ───────── Barre d'annonces ───────── */

  function initAnnbar(bar) {
    if (bar.dataset.navInit) return;
    bar.dataset.navInit = 'true';

    var style = bar.dataset.annbarStyle;

    if (style === 'marquee') {
      var track = bar.querySelector('[data-annbar-track]');
      if (track && !reducedMotion) {
        /* Dupliquer le contenu pour une boucle continue (-50%) */
        track.innerHTML += track.innerHTML;
        var speed = Math.max(20, Math.round(track.scrollWidth / 90));
        track.style.animationDuration = speed + 's';
      } else if (track && reducedMotion) {
        track.style.animation = 'none';
      }
      return;
    }

    var slides = bar.querySelectorAll('.annbar-slide');
    if (slides.length < 2 || reducedMotion) return;

    var interval = (parseInt(bar.dataset.annbarInterval, 10) || 5) * 1000;
    var index = 0;
    var paused = false;

    setInterval(function () {
      if (paused) return;
      slides[index].classList.remove('is-active');
      index = (index + 1) % slides.length;
      slides[index].classList.add('is-active');
    }, interval);

    bar.addEventListener('mouseenter', function () { paused = true; });
    bar.addEventListener('mouseleave', function () { paused = false; });
    bar.addEventListener('focusin', function () { paused = true; });
    bar.addEventListener('focusout', function () { paused = false; });
  }

  /* ───────── Init ───────── */

  function initAll() {
    document.querySelectorAll('[data-header]').forEach(initHeader);
    document.querySelectorAll('[data-annbar]').forEach(initAnnbar);
    initDrawer(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* Éditeur de thème : réinitialiser après rechargement de section,
     et ouvrir le mega menu correspondant quand un bloc est sélectionné */
  document.addEventListener('shopify:section:load', initAll);

  document.addEventListener('shopify:block:select', function (e) {
    var item = e.target.closest('[data-mega]');
    if (item && item._megaOpen) item._megaOpen();
  });

  document.addEventListener('shopify:block:deselect', function (e) {
    var item = e.target.closest('[data-mega]');
    if (item && item._megaClose) item._megaClose();
  });
})();
